import React from 'react';
import PropTypes from 'prop-types';
import { Form, Message } from 'semantic-ui-react';
import api from "../../../../api";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DialogBoxDetail from './DialogBoxDetail';
import WatchPageTutorial from '../../../CommonComponents/WatchPageTutorial';
const regex = new RegExp('^[a-zA-Z0-9 ]+$');


export class DatatableFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: '',
      filterValid: true,
      testModeSwitch: "",
      userToasterColor: "green",
      userToaster: false,
      userToasterMsg: "test",
      modalstatus: false,
      modaltitle: '',
      modalmessage: '',
      modalbuttonmsg: {},
      modalType: '',
      loading: false,
    };
  }

  handleOnChange = (event, { name, value }) => {
    if (value !== '' && !regex.test(value)) {
      this.setState({ [name]: value, filterValid: false });
    } else {
      this.setState({ [name]: value, filterValid: true });
    }
    if (value.trim() == '') {
      this.props.onSubmitFilter(value);
    }
  };

  handleOnClick = () => {
    let value = this.state.filter;
    if (value.trim() !== '') {
      this.props.onSubmitFilter(value);
    }
  };

  componentDidMount() {
    this.loadDetails();
  }

  loadDetails = () => {
    const params = {
      userId: this.props.userId.user_id,
    };
    api.user.getUserAccountTestMode(params).then((res) => {
      if (res.status) {
        this.setState({
          testModeSwitch: res.data.test_mode,
        });
      } else {
        toast.error('Something went wrong! Could not get test mode status.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",

        });
        return;
      }
    });
  }

  changeSwitch = (e) => {
    const testModeSwitch = e.target.checked;
    const modalmessage = testModeSwitch
      ? "Turning test mode on will disable all notifications. Are you sure you want to proceed?"
      : "Turning test mode off will enable all notifications. Are you sure you want to proceed?";
    this.setState({
      modalstatus: true,
      modaltitle: 'Confirm your action',
      modalmessage: modalmessage,
      modalbuttonmsg: { "submit": 'Yes', "cancel": 'No' },
      modalType: 'Delete',
      modalData: testModeSwitch
    });
  }

  modalbuttofun = () => {
    this.setState({ testModeSwitch: this.state.modalData ? "ON" : "OFF", loading: true }, () => {
      const params = {
        userId: this.props.userId.user_id,
        testMode: this.state.testModeSwitch,
      };
      api.user.postUserAccountTestMode(params).then((res) => {
        if (res.status) {
          this.setState({
            modalstatus: false,
            modalstatusAddEdit: false,
            modaltitle: '',
            modalmessage: '',
            modalbuttonmsg: {},
            modalType: '',
            modaldata: {},
            selectedOptions: [],
            subuser_location: 0,
            loading: false,
          });

          toast.success(res.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",

          });
          return;
        } else {

          this.setState({
            modalstatus: false,
            modalstatusAddEdit: false,
            modaltitle: '',
            modalmessage: '',
            modalbuttonmsg: {},
            modalType: '',
            modaldata: {},
            selectedOptions: [],
            subuser_location: 0,
            loading: false
          });

          toast.error(res.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",

          });
          return;
        }
      });
    });
  }

  modalClose = (flag, fm) => {
    this.setState({
      modalstatus: false,
      modalstatusAddEdit: false,
      modaltitle: '',
      modalmessage: '',
      modalbuttonmsg: {},
      modalType: '',
      modaldata: {},
      selectedOptions: [],
      subuser_location: 0,
      loading: false,

    });
  };

  render() {
    const { filter } = this.state;

    return (
      <React.Fragment>
        <div className="kt-form kt-form--label-right kt-margin-t-10 kt-margin-b-10 manage-user-filter-row">
          <div className="row align-items-center">
            <div className="col-xl-12 order-2 order-xl-1">
              <div className="row align-items-center">
                <div className="col-md-4 kt-margin-b-20-tablet-and-mobile">
                  <div className="kt-input-icon kt-input-icon--left">
                    <Message
                      color={
                        this.state.userToasterColor
                          ? this.state.userToasterColor
                          : "green"
                      }
                      style={{
                        display: this.state.userToaster
                          ? "block"
                          : "none",
                        marginTop: 30,
                      }}
                    >
                      {this.state.userToasterMsg}
                    </Message>
                    <Form onSubmit={this.handleOnClick}>
                      <Form.Input
                        style={{ marginLeft: 4 }}
                        name="filter"
                        id="ManageUserCustomInputPadding"
                        className="search-input-mu"
                        value={filter}
                        onChange={this.handleOnChange}
                      />
                    </Form>
                    <span className="kt-input-icon__icon kt-input-icon__icon--left" style={{ cursor: "pointer" }} onClick={this.handleOnClick} >
                      <span>
                        <i className="la la-search" />
                      </span>
                    </span>
                    <span className="yr-searchPlace-holder">Search</span>
                  </div>
                </div>
                <div className="col-md-4 kt-margin-b-20-tablet-and-mobile">

                </div>

                <div className="col-md-4 col-12 kt-margin-b-20-tablet-and-mobile manage-user-actions-col">
                  <div className="d-flex justify-content-end align-items-center manage-user-action-buttons" style={{ height: '100%', gap: '15px' }}>
                    {!this.props.isPLG && (
                    <div className="d-flex align-items-center manage-user-test-mode" style={{ gap: '10px' }}>
                      <h3 className="mh-customColorTitle pl-0 mb-0" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>
                        Test Mode
                      </h3>
                      <div style={{ width: 66 }}>
                        <span
                          className={
                            (this.state.testModeSwitch) === "ON"
                              ? "kt-switch kt-switch-sm kt-switch--success chat-cus-check"
                              : "kt-switch kt-switch-sm kt-switch--error chat-cus-check"
                          }
                        >
                          <label style={{ marginTop: 0, marginBottom: 0 }}>
                            <input
                              name="receive_a_call"
                              type="checkbox"
                              value={this.state.testModeSwitch}
                              onClick={(e) => this.changeSwitch(e)}
                              checked={this.state.testModeSwitch === "ON"}
                              id="custom-switch"
                            />
                            <span />
                          </label>
                        </span>
                      </div>
                    </div>
                    )}
                    <WatchPageTutorial
                      videoKey="manageUsers"
                      className="watch-page-tutorial--inline-left"
                      buttonClassName="btn linear-gradient yr-add-new"
                      buttonText={<>Watch Page Tutorial<i className="fa fa-play-circle ml-2" aria-hidden="true" /></>}
                    />
                    {this.props.addUserButton && (
                      <button
                        className="btn linear-gradient yr-add-new"
                        data-toggle="modal"
                        onClick={this.props.addUserButton}
                      >
                        Add User
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        <DialogBoxDetail
          obj={this.state}
          show={this.state.modalstatus}
          title={this.state.modaltitle}
          message={this.state.modalmessage}
          modalType={this.state.modalType}
          modalClose={this.modalClose}
          buttonmsg={this.state.modalbuttonmsg}
          modalbuttofun={this.modalbuttofun}
          loading={this.state.loading}
          currentChecked={this.state.currentChecked}
          currentExpanded={this.state.currentExpanded}
          setCurrentCheck={this.setCurrentCheck}
          setCurrentExpand={this.setCurrentExpand}
        />
      </React.Fragment>
    );
  }
}

DatatableFilter.propTypes = {
  onSubmitFilter: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
  totalCount: PropTypes.number.isRequired,
};
